import { render } from "./businessCard.vue?vue&type=template&id=adf7ac9e"
import script from "./businessCard.vue?vue&type=script&lang=js"
export * from "./businessCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__